import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';

import ReactHtmlParser from 'react-html-parser';

import { Button, Loader } from 'semantic-ui-react';
import Modal from '../Modal';

import '../../css/LearnosityScoringModal.less';

import { SatCoreComponent, SatCoreRegister } from '../../SatCoreRegistry';

import { VIEW_SELECTION } from '../../managers/NavigationManager';

import { DIALOG_NAMES } from '../../managers/DialogManager';

import UtilityService from '../../services/UtilityService';

import { setSessionStorageItem } from '../../utils/session';

export default
@inject('learnosityItemsManager', 'assignmentManager', 'userManager', 'learnosityDataManager', 'gradebookManager', 'dialogManager')
@observer
class LearnosityScoringModal extends Component {
  gradingApp;
  totalPoints = 0;
  totalMaxPoints = 0;

  constructor(props) {
    super(props);
    this.state = {
      addInfoOpen: false,
      attachedItemCount: 0,
      cancelStart: false,
      errorMessage: '',
      isGradingAPILoaded: false,
      isSaving: false,
      saveComplete: true,
      questionData: null,
      responseData: {},
      activitySessionId: '',
      renderingItems: false,
      showErrorDialog: false,
      unattemptedResponseIds: [],
      updateResponses: false,
      itemCount: 0
    };
    this.InfoModal = SatCoreComponent('InfoModal');
    this.ErrorModal = SatCoreComponent('ErrorModal');
  }

  async componentDidMount() {
    const { learnosityDataManager, activityInstanceId } = this.props;

    // Add Grading api script
    if (!document.getElementById('learnosity-script') ||
      !document.getElementById('learnosity-script').attributes.src.value.includes('grading.learnosity')) {
      const script = document.createElement('script');
      script.src = 'https://grading.learnosity.com/?v2025.1.LTS';
      script.async = true;
      document.body.appendChild(script);
    }

    learnosityDataManager.getLearnosityDataApiResponseScores(activityInstanceId).then( async (data) => {
      if (data && data.status && data.status === 'SUCCESS') {
        if (data.sessionsScores && data.questions) {
          const responseJSON = JSON.parse(data.sessionsScores);
          const questionData = data.questions;
          learnosityDataManager.setResponseJSON(responseJSON);
          learnosityDataManager.setQuestionData(questionData);
          this.setState({ responseData: responseJSON.responses, questionData });
        }
      } else {
        if (data && data.statusMessage) {
          this.openWarningModal(data.statusMessage);
          console.error(`No question data found for assignment: ${activityInstanceId}, message: ${data.statusMessage}`); // TODO do we have a standard notification for this?
        } else {
          this.openWarningModal('An unexpected error has occurred; please try again.');
          console.error(`No question data found for assignment: ${activityInstanceId}`); // TODO do we have a standard notification for this?
        }
        this.setState({ responseData: [], questionData: [] });
      }
      await this.startLoadGradingApp();
    }).catch((err) => {
      console.error(err);
    });
  }

  async componentDidUpdate() {
    const { isGradingAPILoaded, renderingItems, updateResponses} = this.state;
    // if this is the first time, load the activity
    if (!renderingItems && isGradingAPILoaded && !updateResponses) {
      this.renderGradingItems();
    }
  }

  async closeGradingApp() {
    const { updateResponses } = this.state;
    this.props.closeModalCallback(updateResponses);
    await this.clearGradingApp();
  }

  async clearGradingApp() {
    // reset the grading app.  But, we may be using annotations api so check that as well first.
    if (this.gradingApp != null) {
      this.gradingApp.reset();
    }
  }

  // adds a css stylesheet to the dom
  setLearnosityStylesheet(learnosityStylesheet) {
    if (learnosityStylesheet) {
      // if a link exists, delete it.
      const existingStylesheet = document.querySelector('#learnosity-stylesheet');
      if (existingStylesheet) {
        existingStylesheet.parentNode.removeChild(existingStylesheet);
      }
      // create the link
      const link = document.createElement('link');
      link.href = learnosityStylesheet;
      link.rel = 'stylesheet';
      link.type = 'text/css';
      link.id = 'learnosity-stylesheet';
      document.body.appendChild(link);
    }
  }

  async startLoadGradingApp() {
    const { isGradingAPILoaded} = this.state;
    // load the grading app
    // poll/wait for Learnosity javascript to load
    if (!isGradingAPILoaded) {
      const interval = await setInterval(async () => {
        if (window.LearnosityGrading && !this.state.cancelStart) {
          // stop polling
          clearInterval(interval);
          // render the grading api
          await this.loadGrading();
        }
      }, 1000);
    }
  }

  async loadGrading() {
    const { learnosityItemsManager, activityInstanceId } = this.props;
    learnosityItemsManager.getLearnosityItemsInlineGradingApiRequest(activityInstanceId, true).then((requestJson) => {
      const data = JSON.parse(requestJson.data);
      const sessionId = requestJson.sessionId;
      this.setState({activitySessionId: sessionId});

      // Initialize the grading api
      const hookElement = document.querySelector('#l-scoring-card-outer-container');
      console.log('in loadGrading before grading init');//remove
      window.LearnosityGrading.init(JSON.parse(data.init), hookElement).then( async (app) => {
        this.gradingApp = app;
        if (this.gradingApp) {
          this.setGradingAPIEvents();
          console.log('in loadGrading then of grading init: about to set isGradingAPILoaded: true');//remove
          this.setState({isGradingAPILoaded: true});
        }
      }).catch((error) => {
        console.log(error);
      });
    }).catch((err) => {
      this.openWarningModal(err);
      this.setState({ cancelStart: true });
    });
  }

  setGradingAPIEvents () {
    console.log('in setGradingAPIEvents');//remove

    this.gradingApp.on('attachitem:error', function () {
        console.log('attachItem fail');
    });

    this.gradingApp.on('attachitem:start', function () {
        console.log('attachItem started');
    });

    this.gradingApp.on('attachitem:complete', () => {
      const { itemCount, attachedItemCount } = this.state;
      console.log('attachItem complete');
      const newAttachedCount = attachedItemCount + 1;
      // Get the attached items
      if (itemCount === newAttachedCount) {
        this.getAttachedItems();
      }
      this.setState({ attachedItemCount: newAttachedCount });
    }, this);

    this.gradingApp.on('save:start', () => {
        console.log('save: start');
        this.setState({ isSaving: true, saveComplete: false });
    }, this);

    this.gradingApp.on('save:complete', () => {
      const { dialogManager } = this.props;
        console.log('save: complete');
        let title = 'Save'
        let message = 'Scores saved successfully, click "Close" to exit grader.';
        dialogManager.setOpenDialog(DIALOG_NAMES.TEXT, {
          title,
          message
        }, () => dialogManager.closeDialog(DIALOG_NAMES.TEXT));
        this.setState({ isSaving: false, saveComplete: true });
    }, this);

  }

  // processAttachedItems () {
  //     this.getAttachedItems();
  //     this.setState({ attachedItemCount: newAttachedCount });
  // }

  getAttachedItems () {
    // Get the attached items so we can extract the metadata.
    const attachedItemsResponse = this.gradingApp.getAttachedItems();
    const itemsArray = attachedItemsResponse[0]?.items;
    for (const item of itemsArray) {
      const questionsArray = item?.questions;
      for (const question of questionsArray) {
        // Find the question hook in the attached by the grader api
        if (document.getElementById(question.response_id)) {
          const sampleAnswer = question?.metadata?.sample_answer;
          if (sampleAnswer && sampleAnswer.length > 0) {
            const questionHook = document.getElementById(question.response_id);
            const sampleAnswerWrapper = document.createElement('DIV');
            sampleAnswerWrapper.className = 'question-sample-answer-wrapper';
            const divId = `sample-answer-${question.response_id}`;
            sampleAnswerWrapper.innerHTML = 
            `<div id='${divId}' className='question-sample-answer-container'>
                ${sampleAnswer}
            </div>`;
            questionHook.appendChild(sampleAnswerWrapper);
          }
        }
      }
    }
  }

  handleOpenInfo = () => {
    this.setState({ addInfoOpen: true });
  }

  closeInfoModal = () => {
    this.setState({ addInfoOpen: false });
  }

  openWarningModal = (message) => {
    this.setState({ showErrorDialog: true, errorMessage: message });
  }

  closeWarningModal = () => {
    this.setState({ showErrorDialog: false, errorMessage: '' });
  }

  renderStudentInstructionButton = () => {
    const { instruction, isTeacher } = this.props;
    if (instruction && instruction !== '<p></p>') {
      return (
        <Button
          className={(!isTeacher ? 'basic student-instruction white' : 'basic white')}
          onClick={() => this.handleOpenInfo()}
          primary>
          Student Instructions
        </Button>
      );
    }
    return null;
  }

  // create a hook div and attach to the wrapper for learnosity to load each grading item to render
  renderGradingItems = () => {
    const { userManager, studentId, assignerId, isTeacher } = this.props;
    const { activitySessionId, questionData } = this.state;
    const questionRefs = questionData;
    console.log('in renderGradingItems - should be after init returns.');//remove
    this.setState({ renderingItems: true });

    if (questionRefs != null) {
      if (questionRefs.length > 0) {
        this.setState({ itemCount: questionRefs.length });
        const wrapperElement = document.querySelector('#l-scoring-card-outer-container');
        for (let i = 0; i < questionRefs.length; i++) {
          // questions can have objects or strings for references
          const questionRef = questionRefs[i];
          const itemRefId = (typeof questionRef === 'object') ? questionRef.reference : questionRef;
          const itemHookElement = document.createElement('DIV');

          const payload = {
              sessionId: activitySessionId,
              userId: (studentId && isTeacher) ? studentId : userManager.userId,
              item: itemRefId
          };

          const hookUserId = (assignerId && !isTeacher) ? assignerId : userManager.userId;

          itemHookElement.setAttribute('session-id', activitySessionId);
          itemHookElement.setAttribute('user-id', hookUserId);
          itemHookElement.setAttribute('item-reference', itemRefId);
          itemHookElement.className = `lrn-mg-item-hook`;
          wrapperElement.appendChild(itemHookElement);

          this.gradingApp.attachItem(payload, itemHookElement)
        }
      }
    }
  }

  openPrintComponent = async () => {
    const { activityInstanceId, assignmentId, classroomId, contentTitle, contentSubTitle, studentName, grade } = this.props;
    await this.cleargradingApp();
    // Some string params are in session storage because they could contain reserved url chars.
    const instanceData = {
      contentTitle,
      contentSubTitle,
      points: this.totalPoints,
      studentName,
      maxPoints: this.totalMaxPoints,
      grade
    };
    setSessionStorageItem('c2c_printPreviewData', JSON.stringify(instanceData));

    this.props.history.push(`/lrnPrint?activityInstanceId=${activityInstanceId}&assignmentId=${assignmentId}&classroomId=${classroomId}&returnView=${VIEW_SELECTION.GRADEBOOK}`);
  }

  saveTeacherScores = async () => {
    console.log('in saveTeacherScores');//remove
    if (this.gradingApp) {
      try {
        const savedResult = await this.gradingApp.save();
        this.setState({ updateResponses: true });
      } catch (e) {
        console.log(`code ${e.code} message: ${e.message}`);
        this.openWarningModal(e.message)
        this.setState({ isSaving: false, saveComplete: true });
      }
    }
  }

  ProgressBar = (props) => {
    const { color, percent } = props;
    return (
      <div className={`progress-bar ${color}`}>
        <div className={color} style={{ width: `${percent}%`, maxWidth: '100%' }} />
      </div>
    );
  }

  render() {
    const { InfoModal } = this;
    const { ErrorModal } = this;
    const { ProgressBar } = this;
    const { gradebookManager, t } = this.props;
    const gradeClassName = gradebookManager.getGradeClassName(this.props.grade);
    const transformFn = UtilityService.reactHtmlParserTransform;
    const processedContentTitle = this.props.contentTitle ? UtilityService.reactHtmlParserWrapper(this.props.contentTitle).parsedNoPWrap : '';
    const processedContentSubTitle = this.props.contentSubTitle ? UtilityService.reactHtmlParserWrapper(this.props.contentSubTitle).parsedNoPWrap : '';
    return (
      <div className='learnosity-modal-container'>
        <Modal
          className='l-scoring-modal'
          onMount={() => document.body.classList.add('body-l-scoring-modal')}
          onUnmount={() => document.body.classList.remove('body-l-scoring-modal')}
          open
          size='fullscreen'>
          <div className='l-scoring-modal-container'>
            <div className='l-scoring-modal-upper-header'>
              <div className='modal-title-text'>
                {this.props.isTeacher && (
                  <div className='title-text'>
                    {t('gradebookLabel', 'LearnosityViewerModal translation missing.')}
                    :
                    {' '}
                    {this.props.studentName}
                  </div>
                )}
                {!this.props.isTeacher && (
                  <div className='title-text'>
                    {processedContentTitle}
                  </div>
                )}
              </div>
              <div className='modal-title-button'>
                {this.renderStudentInstructionButton()}
                {this.state.isGradingAPILoaded && this.props.isTeacher && this.props.canManageScores && (
                  <Button
                    className={(!this.props.isTeacher ? 'basic student white' : '')}
                    onClick={() => this.openPrintComponent()}
                    primary>
                    Print Preview
                  </Button>
                )}
                <Button
                  className={(!this.props.isTeacher ? 'basic student white' : '')}
                  disabled={!this.state.saveComplete}
                  onClick={() => this.closeGradingApp()}
                  primary>
                  Close
                </Button>
                {this.props.isTeacher && this.props.canManageScores && (
                  <Button
                    className={(!this.props.isTeacher ? 'basic student white' : '')}
                    disabled={!this.state.isGradingAPILoaded}
                    onClick={() => this.saveTeacherScores()}
                    primary>
                    {this.state.isSaving ? <Loader active inline size='tiny' /> : 'Save'}
                  </Button>
                )}
              </div>
            </div>
            <div className='l-scoring-modal-header-container'>
              <div className='l-scoring-modal-header'>
                <div className='scoring-modal-header-title'>
                  <div className='header-student-name'>
                    {processedContentTitle}
                  </div>
                  <div className='header-resource-name'>
                    {processedContentSubTitle}
                  </div>
                </div>
                {!this.props.isTeacher && (
                <div className='progress-bar-container'>
                  <div className={`progress-text ${gradeClassName}`}>
                    {this.props.grade}
                    %
                  </div>
                  <ProgressBar color={gradeClassName} percent={this.props.grade} />
                </div>
                )}
                {/* <Image className={'feedback clickable'} src={iconCommentNone} /> This may be added back later */}
              </div>
            </div>
            <div className='l-scoring-card-outer-container' id='l-scoring-card-outer-container'></div>
          </div>
          <InfoModal
            addInfoOpen={this.state.addInfoOpen}
            closeInfoModal={this.closeInfoModal}
            contentItemDescription={null}
            imageUrl={this.props.contentImageUrl}
            infoName={this.props.resourceName}
            resourceInfo={null}
            studentInstruction={this.props.instruction} />
          <ErrorModal
            addErrorOpen={this.state.showErrorDialog}
            closeErrorModal={this.closeWarningModal}
            errorMessage={this.state.errorMessage} />
        </Modal>
      </div>
    );
  }
}

SatCoreRegister('LearnosityScoringModal', LearnosityScoringModal);
